import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api"
import type { NotificationSettingsItem } from "../types/notification.types"

const BASE_URL = "/notifications"

export const NOTIFICATION_PATHS = {
  getNotifications: (accessToken: string) =>
    `${import.meta.env.VITE_APP_BASE_API_WS_ROUTE}/notifications/?token=${accessToken}`,
  getNotificationSettings: `${BASE_URL}/notification_settings/`,
  updateNotificationSettings: `${BASE_URL}/notification_settings/`
}

export const getNotificationSettings = (): Promise<ApiResponse<any>> => {
  return request.api.get(NOTIFICATION_PATHS.getNotificationSettings)
}

export const updateNotificationSettings = (
  data: Partial<NotificationSettingsItem>[]
): Promise<ApiResponse<any>> => {
  return request.api.patch(NOTIFICATION_PATHS.updateNotificationSettings, data)
}
